<div class="w-full cursor-pointer" (click)="selectMethod($event)" >
  <div class="grid grid-cols-4 gap-2">
    <div class="col-span-2">
      <img class="other-payment-options" src="assets/icons/Icons/other-payment-options/google-pay-mark.png"
           alt="google pay">
    </div>
    <div class="col-span-2">
      <div class="w-full align-middle inline-flex justify-start gap-4">
      </div>
    </div>
  </div>
  <div class="mt-2 grid grid-cols-5 gap-1">
    <p style="margin-top: 0.1rem !important;" class="col-span-4 subtext mt-2">Pay seamlessly using Google Pay™</p>
    <div class="col-span-1">
        <mat-icon class="cursor-pointer float-right" (click)="toggleListView()">info</mat-icon>
      </div>
    </div>
</div>
